import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import openUserStories from '../openUserStories';
import { emojiFor } from '../reactions';

/**
 * "<user> reacted to your story", naming the reaction.
 *
 * The story lives behind the stories endpoint rather than a route, so the
 * notification opens the viewer instead of navigating. Stories expire within
 * a day; openUserStories handles one that is already gone.
 */
export default class StoryLikedNotification extends Notification {
  /**
   * The reaction, from the attribute the notification serializer adds.
   *
   * Not from content(): core matches notifications on their data, so keeping
   * the reaction there turned each different reaction into a separate
   * notification. Missing means a notification from before reactions existed,
   * which was a like — the heart.
   */
  reaction() {
    return this.attrs.notification.attribute('storyReaction') || 'heart';
  }

  icon() {
    return 'fas fa-heart';
  }

  href() {
    // The story is the actor's own, and it lives behind the stories endpoint
    // rather than a route — onclick opens the viewer. This only has to be a
    // path core can inspect for its external-link check.
    return app.route('index');
  }

  /**
   * Core wires its own markAsRead to the notification link, so there is no
   * onclick hook to implement — the story is opened by extending that.
   */
  markAsRead(e) {
    if (e) e.preventDefault();

    super.markAsRead();

    // It is the actor's own story that was liked.
    if (app.session.user) openUserStories(app.session.user);
  }

  content() {
    return app.translator.trans('happydigital-stories.forum.notifications.story_reacted', {
      // The model itself, not its name: Flarum runs a {user} parameter through
      // its username helper, which calls displayName() and renders "[deleted]"
      // on its own when the account is gone.
      user: this.attrs.notification.fromUser(),
      // The emoji rather than a word for the reaction: it is what the person
      // actually tapped, and it reads the same in any language.
      emoji: emojiFor(this.reaction()),
    });
  }

  excerpt() {
    return null;
  }
}
